import { combineEpics } from 'redux-observable';

import fetchGlobalMailSubscriptions from './epics/fetchGlobalMailSubscriptions';

export default combineEpics(fetchGlobalMailSubscriptions);
